import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { metersToFeet } from "@/src/helpers/metersToFeet";

import { cn } from "@/src/lib/utils";

const SliderLength = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    thumbs?: (string | number)[];
  }
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className,
      !!props.thumbs?.length && "pb-9",
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
    <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
    {!!props.thumbs?.length && (
      <div className="w-full absolute bottom-0 flex align-center justify-between top-5">
        {props.thumbs?.map((thumb, i) => (
          <span key={i} className={"text-xs leading-5 flex flex-col gap-1"}>
            {metersToFeet(+thumb)}
            <span>
              <span className="rounded-full bg-blue-100 text-neutral-400 text-xs p-1 font-medium leading-5 tracking-[-0.12px] ">
                {thumb + "m"}
              </span>
            </span>
          </span>
        ))}
      </div>
    )}
  </SliderPrimitive.Root>
));
SliderLength.displayName = SliderPrimitive.Root.displayName;

export { SliderLength };
